import React from 'react';
import ProductionDays from './ProductionDays';

export const ProductionDaysContext = React.createContext({});

export default ProductionDays;
